/**
 * TanStack Query hooks for `influencer-hierarchy`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	influencerHierarchyQueryKeys,
	type CreateInfluencerHierarchyBody,
	type ListInfluencerHierarchyResponse,
	type InfluencerHierarchyRow,
} from "./api";

export function useInfluencerHierarchyList(): UseQueryResult<ListInfluencerHierarchyResponse, Error> {
	return useQuery({
		queryKey: influencerHierarchyQueryKeys.list(),
		queryFn: list,
	});
}

export function useInfluencerHierarchyCreate(): UseMutationResult<InfluencerHierarchyRow, Error, CreateInfluencerHierarchyBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: influencerHierarchyQueryKeys.all });
		},
	});
}

export function useInfluencerHierarchyDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: influencerHierarchyQueryKeys.all });
		},
	});
}
